<template lang="pug">
#mobile-sidebar(:class="{ activated: $store.state.mobileSidebarActivated }", :style="{ left: dynamicLeft, width: dynamicWidth }")
  .sidenav.mobile
    ul.nav
      // li.sidebar-close-button(@click="closeMobileSideNav") X
      router-link.sidebar-yellow(to="/happenings")
        li HAPPENINGS
      router-link.sidebar-yellow(to="/new")
        li NEW
      li.theme(@click="activateThemeSidebar", :class="{ active: $store.state.sidebarThemeActivated }") THEMES
      router-link.sidebar-yellow(to="/sale")
        li SALE
</template>

<script>
export default {
  mounted () {
    setInterval(() => {
      if (!this.$store.state.mobileSidebarActivated) {
        window['mobile-sidebar'].style.left = `calc(-${window.innerHeight + 1000}px + 65px)`
      } else {
        window['mobile-sidebar'].style.width = `calc(${window.innerHeight}px - 65px)`
        window['mobile-sidebar'].style.left = `calc(-${window.innerHeight}px + 65px)`
      }
    }, 500)
  },

  computed: {
    dynamicLeft () {
      if (!this.$store.state.mobileSidebarActivated) {
        return `calc(-${window.innerHeight + 1000}px + 89px)`
      } else {
        return `calc(-${window.innerHeight}px + 89px)`
      }
    },

    dynamicWidth () {
      return `calc(${window.innerHeight}px - 89px)`
    }
  },
  methods: {
    closeMobileSideNav () {
      this.$store.commit('setSidebarThemeState', false)
      this.$store.commit('setMobileSidebarState', false)
    },

    activateThemeSidebar () {
      if (this.$store.state.sidebarThemeActivated) {
        this.$store.commit('setSidebarThemeState', false)
      } else {
        this.$store.commit('setSidebarThemeState', true)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../sass/_variables.sass'

#mobile-sidebar
  position: fixed
  top: 0
  // left: calc(-120vh + 107px)
  transform-origin: right top
  z-index: 200
  transform: rotate(-90deg)
  background-color: white
  // width: calc(100vh - 107px)
  transition: 0.3s all
  &.activated
    // left: calc(-100vh + 107px)
  .sidenav
    // background-color: white
    // transform: rotate(-90deg)
    // position: absolute
    // transform-origin: left top
    // bottom: calc(0px - 45px)
    z-index: 10
    box-shadow: 0px 0px 1px 1px white
    ul
      display: flex
      .sidebar-yellow
        flex: 1
        cursor: pointer
      li
        text-align: center
        font-weight: 900
        font-style: italic
        color: #212121
        padding: 12px 0px
        font-size: 16px
        box-sizing: border-box
        cursor: pointer
        flex: 1
        &.theme
          background-color: $light-yellow
        &.sidebar-close-button
          flex: 0 0 10%
          background-color: $yellow !important
          border-left: 1px solid white
        &.active
          background-color: $yellow !important
      &.nav
        width: 100%
        .sidebar-yellow
          background-color: $light-yellow
          box-shadow: 0px 0px 1px 1px white
          // width: 128px
          &.active
            background-color: $yellow !important
</style>
